import { Box } from '@hivebrite/design-system/Box';
import { Slider } from '@hivebrite/design-system/Slider';

import LoadingItem from 'hb-react/shared/components/Carousel/components/LoadingItem';

const CARDS_PER_ROW = {
  s: 1,
  m: 2,
  l: 3,
  xl: 3,
};

const Carousel = ({
  items,
  ElementComponent,
  infinite = true,
  cardPerRow = CARDS_PER_ROW,
}) => (
  <Box width={{ _: '90%', m: '100%' }} display="block" mx="auto">
    <Slider
      items={items}
      ItemComponent={ElementComponent}
      perPageBreakpoints={cardPerRow}
      infinite={items?.length === 1 ? false : infinite}
      total={items.length}
      LoadingItemComponent={LoadingItem}
      totalSlides={items.length}
    />
  </Box>
);

export default Carousel;
